import React from "react";
import { Card, CardContent, Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
export default function NotFoundCard({ title }) {
  return (
    <Card
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        //   width: "50%",
        height: "20vh",
        marginLeft: "auto",
        marginRight: "auto",
        borderBottom: "0px",
      }}
    >
      <CardContent style={{ display: "contents" }}>
        <ErrorOutlineIcon style={{ fontSize: "4rem", color: "#ccc" }} />
        <Typography variant="h5">{title}</Typography>
      </CardContent>
    </Card>
  );
}
